import { render, staticRenderFns } from "./RefundLogistics.vue?vue&type=template&id=ffd7e9c8&scoped=true&"
import script from "./RefundLogistics.vue?vue&type=script&lang=js&"
export * from "./RefundLogistics.vue?vue&type=script&lang=js&"
import style0 from "./RefundLogistics.vue?vue&type=style&index=0&id=ffd7e9c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd7e9c8",
  null
  
)

export default component.exports